import { Button } from "lumir-back-office-ui";
import { TextDisplay } from "lumir-back-office-ui/RmsTextDisplay";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import recruitServiceV1 from "../../../api/renewal/recruit.service.v1";
import FaqFooter from "../../../components/templates/faqFooter";
import useDisplay from "../../../hooks/useDisplay";
import { route } from "../../../router/route";
import {
  BackButton,
  RecruitContents,
  RecruitInfoSidebar,
  RecruitInfoSidebarM,
} from "./_component";

export default function NewJobAnnounceDetail() {
  const { isMobile, isTablet } = useDisplay();
  const isSmall = isMobile || isTablet;
  const { id } = useParams();

  const [jobDescription, setJobDescription] = useState({
    title: "",
    contents: [],
    recruitImg: "",
    info: {
      careerLevel: "",
      positionType: "",
      deadline: "",
      location: "",
      salary: "",
    },
  });

  useEffect(() => {
    const fetchJobDescription = async () => {
      try {
        const response = await recruitServiceV1.getRecruitDetail(id);
        if (!response || !response.title) {
          throw new Error("Invalid response format");
        }
        setJobDescription(response);
      } catch (err) {
        console.error("Error fetching job description:", err);
      }
    };
    fetchJobDescription();
  }, [id]);

  const navigate = useNavigate();

  return (
    <div id="tailwind-root">
      <div className="flex gap-4 min-h-screen relative">
        {isSmall ? (
          <section
            className={`flex flex-col justify-between gap-[40px] max-w-[1400px] w-full mx-auto mt-32 ${
              isMobile ? "px-[20px]" : "px-[70px]"
            }`}
          >
            <BackButton />
            <TextDisplay
              size="lg"
              textData={{
                primary: jobDescription.title,
              }}
            />
            <RecruitInfoSidebarM
              careerLevel={jobDescription.info.careerLevel}
              positionType={jobDescription.info.positionType}
              deadline={jobDescription.info.deadline}
              location={jobDescription.info.location}
              salary={jobDescription.info.salary}
            />
            <div className="flex-1">
              <RecruitContents
                title={jobDescription.title}
                jobDescription={jobDescription.contents}
                recruitImg={jobDescription.recruitImg}
                positionPostType={jobDescription.positionPostType}
                isMobile={true}
                stage={jobDescription.stage}
              />
            </div>
            <div className="mt-[24px] sticky bottom-0 left-0 right-0 bg-white p-[16px]">
              <Button
                size="xlg"
                variant="filled"
                state="primary"
                className="w-full h-[36px] cursor-none custom-cursor"
                onClick={() =>
                  navigate(`${route.apply}/${id}?title=${jobDescription.title}`)
                }
              >
                지원하기
              </Button>
            </div>
          </section>
        ) : (
          <section
            className={`flex justify-between gap-40 max-w-[1400px] w-full mx-auto my-32 ${
              isSmall ? "px-[70px]" : isMobile ? "px-[20px]" : ""
            }`}
          >
            <div className="flex-1">
              <BackButton />
              <p className="typography-semantic-title-2-bold mt-16">
                {jobDescription.title}
              </p>
              <RecruitContents
                title={jobDescription.title}
                jobDescription={jobDescription.contents}
                recruitImg={jobDescription.recruitImg}
                positionPostType={jobDescription.positionPostType}
                stage={jobDescription.stage}
              />
            </div>
            <section className="w-[400px] sticky top-[32px] self-start max-h-[calc(100vh-64px)] overflow-y-auto">
              <RecruitInfoSidebar
                careerLevel={jobDescription.info.careerLevel}
                positionType={jobDescription.info.positionType}
                deadline={jobDescription.info.deadline}
                location={jobDescription.info.location}
                salary={jobDescription.info.salary}
                id={id}
                title={jobDescription.title}
              />
            </section>
          </section>
        )}
      </div>
      <FaqFooter />
    </div>
  );
}
